// The booking form page. Sends the form to the back-end which
// takes the form and sends its details in an email to the lands end park email, and a confirmation
// email to the customer's email address

// IMPORTS
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs"; // for passing test values to datepickers
import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  MenuItem,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useLayoutEffect, useRef } from "react";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";

// export function AddLibrary(urlOfTheLibrary) {
//   const script = document.createElement("script");
//   script.src = urlOfTheLibrary;
//   script.async = true;
//   document.body.appendChild(script);
// }

// THE ACTUAL COMPONENT (ARE PROPS USED ANYWHERE?)
// also figure out what the location is doing
export const Book = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const ref = useRef(null);

  //State variables
  const [dialogIsOpen, setDialogIsOpen] = useState(false);
  const [canadaOrOther, setCanadaOrOther] = useState("Canada"); //defaults to Canada so that Postal code and address show
  const [country, setCountry] = useState("Canada");
  const [postalCode, setPostalCode] = useState("");
  const [postalCodeError, setPostalCodeError] = useState(false);
  const [address, setAddress] = useState("");
  const [monerisCheckoutLoaded, setMonerisCheckoutLoaded] = useState(false);
  const [numNights, setNumNights] = useState(0);
  const [loading, setLoading] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [arrivalDate, setArrivalDate] = useState();
  const [dateErrorMessage, setDateErrorMessage] = useState("");
  const [departureDate, setDepartureDate] = useState();
  const [numAdults, setNumAdults] = useState("");
  const [numChildren, setNumChildren] = useState("");
  const [childrenAges, setChildrenAges] = useState("");
  const [campingUnitLength, setCampingUnitLength] = useState("");
  const [extraInfo, setExtraInfo] = useState("");
  const [numElectricVehicles, setNumElectricVehicles] = useState("");
  const [campingUnit, setCampingUnit] = useState("");
  const [extras, setExtras] = useState([]);
  const [checkInTime, setCheckInTime] = useState("");
  const [siteType, setSiteType] = useState(
    location.state != null ? location.state.siteType : "",
  );
  const [backupSiteType, setBackupSiteType] = useState("");
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [firstNameError, setFirstNameError] = useState(false);
  const [lastNameError, setLastNameError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [phoneNumberError, setPhoneNumberError] = useState(false);
  const [siteTypeError, setSiteTypeError] = useState(false);
  const [arrivalDateError, setArrivalDateError] = useState(false);
  const [departureDateError, setDepartureDateError] = useState(false);
  const [numAdultsError, setNumAdultsError] = useState(false);
  const [numChildrenError, setNumChildrenError] = useState(false);
  const [campingUnitError, setCampingUnitError] = useState(false);
  const [campingUnitLengthError, setCampingUnitLengthError] = useState(false);
  const [acceptTermsMessage, setAcceptTermsMessage] = useState("");

  //season start and end dates (for deposit calculation and for datepickers)
  const summerStart2025 = new Date("2025-06-13").getTime();
  const summerEnd2025 = new Date("2025-08-31").getTime();
  const summerStart2026 = new Date("2026-06-12").getTime();
  const summerEnd2026 = new Date("2026-09-06").getTime();
  const closeDate2025 = new Date("2025-10-14").getTime(); //close date should be the day after thanksgiving monday
  const openDate2026 = new Date("2026-05-01").getTime();
  const closeDate2026 = new Date("2026-10-11").getTime();

  useEffect(() => {
    //autofill inputs
    // setFirstName("John");
    // setLastName("Smith");
    // setEmail("nickpsotka@outlook.com");
    // setPhoneNumber("777-777-7777");
    // setAddress("Corey Crescent");
    // setPostalCode("N0H 2R0");
    // setNumAdults("2");
    // setNumChildren("0");
    // setCampingUnit("Tent");
    // setCampingUnitLength("15");
    // setCheckInTime("Afternoon (1:00pm - 5:00pm)");
    // setAcceptTerms(true);

    //check the arrival dates and departure dates every time one is changed
    //don't run the check if either value hasn't been selected yet
    if (
      typeof arrivalDate === "undefined" ||
      typeof departureDate === "undefined"
    ) {
      return;
    }

    //run the check for arrival date being after departure date.
    if (!departureDate.isAfter(arrivalDate)) {
      setDateErrorMessage(
        "Your departure date must be after your arrival date.",
      );
      setNumNights(0);
      return;
    } else {
      setDateErrorMessage("");

      // Calculating the time difference
      // of two dates
      let Difference_In_Time =
        departureDate.$d.getTime() - arrivalDate.$d.getTime();

      // Calculating the no. of days between
      // two dates
      setNumNights(Math.round(Difference_In_Time / (1000 * 3600 * 24)));
    }
  }, [arrivalDate, departureDate]);

  //test mode
  const TEST_MODE = false;
  var URL = "https://landsendpark.com";
  if (TEST_MODE) {
    URL = "http://localhost:7297";
  }
  //https://win1083.site4now.net:8172/MsDeploy.axd?site=landsendpark-001-site1 did not work

  //Event handler for the extras (screen tent, dining tent, extra car) checkboxes
  //Doesn't make sense to make it an anonymous function since it's called by all three checkboxes
  const handleExtrasChange = (event) => {
    //first check to see if the extra has already been added to the array of extras
    const index = extras.indexOf(event.target.value);
    if (index === -1) {
      //if it hasn't already been added add it
      setExtras([...extras, event.target.value]);
    } else {
      //if it's been added take it out
      setExtras(extras.filter((extra) => extra !== event.target.value));
    }
  };

  // THE ACTUAL PAGE
  return (
    <div className="page">
      {/* Dialog that shows if a payment is declined */}
      <Dialog open={dialogIsOpen} onClose={() => setDialogIsOpen(false)}>
        <DialogTitle sx={{ paddingBottom: 0 }}>Failed Payment</DialogTitle>

        <DialogContent>
          There was an error with your payment. This could be something like an
          incorrect credit card expiry date or CVV, or an error verifying that
          the address entered matches the address of the credit card. Please try
          again or use a different card.
        </DialogContent>
        {/* justifyContent spaceBetween puts the "previous" button on the left */}
        <DialogActions style={{ justifyContent: "space-between" }}>
          <IconButton
            sx={{
              position: "absolute",
              left: "91%",
              top: "2%",
              backgroundColor: "lightgray",
              color: "gray",
            }}
            onClick={() => setDialogIsOpen(false)}
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </Dialog>

      {/* add the moneris checkout script */}
      {/* {AddLibrary("https://gatewayt.moneris.com/chktv2/js/chkt_v2.00.js")} */}
      {/* this div is needed to connect to moneris checkout */}
      <div id="monerisCheckout"></div>
      {!monerisCheckoutLoaded ? (
        <div>
          <Typography
            gutterBottom
            sx={{ backgroundColor: "#ffee90", p: 2, mx: "0.7%" }}
          >
            Completion of this form does not guarantee a reservation; each
            application is reviewed by our staff and if we have a suitable site
            available, we will accept the deposit and send a confirmation email
            within 24 hours. In the meantime, you may see a "Pending" or
            "Authorized" transaction on your card.
          </Typography>
          <Typography
            gutterBottom
            sx={{ backgroundColor: "#ffee90", p: 2, mx: "0.7%" }}
          >
            {/* NOTE: We do not accept group reservations. */}
            NOTE: We have rules in place to ensure that everyone can have a
            relaxing camping experience. Please be aware that all music must be
            shut off at 11:00 PM, and voices kept down to a quiet{" "}
            {/* whisper. For group reservations (more than 2 adults), at 11:00 PM */}
            whisper (yes, we really mean a quiet whisper). For anyone camping
            with more than 2 adults total, at 11:00 PM you must shut campfires
            down and go back to your own sites.
            {/* This is so that any sites near
            you can be assured they will have a pleasant{" "}
            {/* camping experience that won't be disturbed by being next to a group. */}
            {/* camping experience that won't be disturbed by the site next to them. */}
          </Typography>
          <Typography
            gutterBottom
            sx={{ backgroundColor: "#cbe6ef", p: 2, mx: "0.7%" }}
          >
            Unserviced sites have a 4 night minimum stay on Civic long weekend
            (July 31 - August 3). All other weekends from July 3
            - Sept. 7 have a 3 night minimum stay.
            {/* The paragraph below is what we had posted from June 6 - 21, 2026 */}
            {/* Unserviced sites have a 4 night minimum stay on Canada Day weekend
            (June 26 - 29) and Civic long weekend (July 31 - August 3).
            Regular-serviced sites have a 4 night minimum on Canada Day weekend
            (June 26 - 29). All other weekends from July 3 - Sept. 7 have a 3
            night minimum stay. */}
            {/* The paragraph below is what we had posted until June 6, 2026 */}
            {/* Canada Day long weekend (June 26 - 29) has a 4 night minimum stay.
            Civic Holiday long weekend (July 31 - August 3) has a 5 night
            minimum stay. All non-holiday weekends in July/August have a 3 night
            minimum stay. */}
            {/* The reason for these minimum stays is so that sites
            don't all fill up with two-night stays on weekends, which in the
            past has prevented campers from being able to plan longer camping
            trips for the rest of the summer, since every weekend is taken by
            two-night stays. */}
            {/* The reason for these minimum stays is so that our sites don't all 
            fill up with two-night stays on weekends, a few months before the summer, 
            which would prevent anyone from being able to plan longer camping trips for the rest of the 
            summer, since every Friday and Saturday would be filled with two night stays.*/}
          </Typography>
          <div className="two-per-line">
            <TextField
              ref={ref}
              value={firstName}
              onChange={(event) => {
                setFirstName(event.target.value);
                setFirstNameError(false);

                //test mode
                if (firstName === "TEST RESERVATION") {
                  console.log("Test mode. Deposit should be $0.15");
                  if (lastName === "") setLastName("testing the website");
                  if (email === "") setEmail("nickpsotka@outlook.com");
                  if (phoneNumber === "") setPhoneNumber("000-000-0000");
                  if (address === "") setAddress("51 red street");
                  if (postalCode === "") setPostalCode("N0H 2R0");
                  if (siteType === "") setSiteType("Unserviced");
                  if (typeof arrivalDate === "undefined")
                    setArrivalDate(dayjs("2026-09-07"));
                  if (typeof departureDate === "undefined")
                    setDepartureDate(dayjs("2026-09-12"));
                  if (numAdults === "") setNumAdults("2");
                  if (numChildren === "") setNumChildren("0");
                  if (campingUnit === "") setCampingUnit("Travel Trailer");
                  if (campingUnitLength === "") setCampingUnitLength("14");
                  setAcceptTerms(true);
                }
              }}
              sx={{ margin: "6px" }}
              className="input"
              label="First Name"
              fullWidth
              error={firstNameError}
              helperText={firstNameError ? "Required" : ""}
            />
          </div>
          <div className="two-per-line">
            <TextField
              value={lastName}
              onChange={(event) => {
                setLastName(event.target.value);
                setLastNameError(false);
              }}
              sx={{ margin: "6px" }}
              label="Last Name"
              fullWidth
              error={lastNameError}
              helperText={lastNameError ? "Required" : ""}
            />
          </div>
          <div className="two-per-line">
            <TextField
              value={email}
              onChange={(event) => {
                setEmail(event.target.value);
                setEmailError(false);
              }}
              sx={{ margin: "6px" }}
              label="Email"
              fullWidth
              error={emailError}
              helperText={emailError ? "Valid email required" : ""}
            />
          </div>
          <div className="two-per-line">
            <TextField
              value={phoneNumber}
              onChange={(event) => {
                setPhoneNumber(event.target.value);
                setPhoneNumberError(false);
              }}
              sx={{ margin: "6px" }}
              label="Phone Number"
              fullWidth
              error={phoneNumberError}
              helperText={phoneNumberError ? "Required" : ""}
            />
          </div>
          <div className="two-per-line">
            <TextField
              value={canadaOrOther}
              onChange={(event) => {
                setCanadaOrOther(event.target.value);
                if (event.target.value === "Other") {
                  setCountry("");
                }
              }}
              sx={{ margin: "6px" }}
              className="input"
              label="Country of Residence"
              fullWidth
              select
            >
              <MenuItem value="Canada">Canada</MenuItem>
              <MenuItem value="Other">Other (please specify)</MenuItem>
            </TextField>
          </div>
          {canadaOrOther === "Canada" ? (
            <div className="two-per-line">
              <TextField
                value={address}
                onChange={(event) => {
                  setAddress(event.target.value);
                }}
                sx={{ margin: "6px" }}
                label="Address"
                fullWidth
              />
              <TextField
                value={postalCode}
                onChange={(event) => {
                  setPostalCode(event.target.value);
                  setPostalCodeError(false);
                }}
                sx={{ margin: "6px" }}
                label="Postal Code"
                fullWidth
                error={postalCodeError}
                helperText={
                  postalCodeError
                    ? "Valid Postal Code Required or Pick Country Other Than Canada"
                    : ""
                }
              />
            </div>
          ) : (
            <div className="two-per-line">
              <TextField
                value={country}
                onChange={(event) => {
                  setCountry(event.target.value);
                }}
                sx={{ margin: "6px" }}
                label="Specify Country"
                fullWidth
              />
            </div>
          )}
          <div className="one-per-line">
            <Typography color="text.secondary" sx={{ ml: 1.5 }}>
              Site type / size guide: If your trailer is above 23', please
              select premium-serviced as your first choice, as most of our
              regular-serviced sites will not fit trailers above 23'. If your
              trailer is between 20 - 23 feet (and you don't require 50-Amp)
              please select a combo of <strong>both</strong> regular{" "}
              <strong>and</strong> premium-serviced as your site type and
              alternative site type (in your order of preference). This way we
              can do our best to get you on your preferred site type, and we'll
              also have the flexibility to try and get you on your alternative
              site type as a backup.
              {/* The main difference between our regular and premium
              sites is their size.{" "} */}
              <Link to="/sites" target="_blank" rel="noopener noreferrer">
                Click here
              </Link>{" "}
              for prices and more info on our sites.
            </Typography>
          </div>
          <div className="two-per-line">
            <TextField
              sx={{ margin: "6px" }}
              label="Requested Type of Campsite*"
              select
              value={siteType}
              onChange={(event) => {
                setSiteType(event.target.value);
                if (event.target.value.includes("Cabin")) {
                  setCampingUnit("Cabin");
                }
                setSiteTypeError(false);
              }}
              fullWidth
              error={siteTypeError}
              helperText={siteTypeError ? "Required" : ""}
            >
              <MenuItem value="Unserviced">
                Unserviced (no electricity or water: meant for small camping
                units)
              </MenuItem>
              <MenuItem value="Regular Serviced">
                Regular Serviced (15/30 Amp outlet and water tap: meant for
                small camping units)
              </MenuItem>
              <MenuItem value="Premium Serviced">
                Premium Serviced (15/30 Amp outlet and water tap: meant for
                medium/large camping units)
              </MenuItem>
              <MenuItem value="50 Amp">
                Serviced 50 Amp (50 Amp outlet and water tap: meant for large
                camping units)
              </MenuItem>
              <MenuItem value="Cabin">
                Cabin (15 Amp outlet and water tap outside of cabin)
              </MenuItem>
            </TextField>
          </div>
          <div className="two-per-line">
            <TextField
              sx={{ margin: "6px" }}
              label="Alternative Campsite Type (if requested type of site is unavailable)"
              select
              value={backupSiteType}
              onChange={(event) => {
                setBackupSiteType(event.target.value);
              }}
              fullWidth
            >
              <MenuItem value="Unserviced">
                Unserviced (no electricity or water: meant for small camping
                units)
              </MenuItem>
              <MenuItem value="Regular Serviced">
                Regular Serviced (15/30 Amp outlet and water tap: meant for
                small camping units)
              </MenuItem>
              <MenuItem value="Premium Serviced">
                Premium Serviced (15/30 Amp outlet and water tap: meant for
                medium/large camping units)
              </MenuItem>
              <MenuItem value="50 Amp">
                Serviced 50 Amp (50 Amp outlet and water tap: meant for large
                camping units)
              </MenuItem>
              <MenuItem value="Cabin">
                Cabin (15 Amp outlet and water tap outside of cabin)
              </MenuItem>
              <MenuItem value="None">No Substitutions</MenuItem>
            </TextField>
          </div>
          <div className="two-per-line">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={arrivalDate}
                sx={{ margin: "6px" }}
                label="Arriving On*"
                slotProps={{ textField: { fullWidth: true } }}
                onChange={(newValue) => {
                  setArrivalDate(newValue);
                }}
                disablePast
                shouldDisableDate={(date) => {
                  //The logic doesn't totally logic, I think something is up with new Date getTime() being different from the one that comes from the DatePicker.
                  return (
                    (date.$d.getTime() > closeDate2025 &&
                      date.$d.getTime() < openDate2026) ||
                    date.$d.getTime() > closeDate2026
                  );
                }}
              />
            </LocalizationProvider>
          </div>
          <div className="two-per-line">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={departureDate}
                sx={{ margin: "6px" }}
                label="Leaving On*"
                slotProps={{ textField: { fullWidth: true } }}
                onChange={(newValue) => {
                  setDepartureDate(newValue);
                }}
                disablePast
                shouldDisableDate={(date) => {
                  //The logic doesn't totally logic, I think something is up with new Date getTime() being different from the one that comes from the DatePicker.
                  return (
                    (date.$d.getTime() > closeDate2025 &&
                      date.$d.getTime() < openDate2026) ||
                    date.$d.getTime() > closeDate2026
                  );
                }}
              />
            </LocalizationProvider>
          </div>
          {/* If the dateErrorMessage is not empty, show it beneath the DatePickers */}
          {dateErrorMessage === "" ? (
            <div className="one-per-line">{/* {arrivalDate} */}</div>
          ) : (
            <div className="one-per-line">
              <Typography
                sx={{
                  backgroundColor: "#ffee90",
                  p: 2,
                  clear: "both",
                  width: "auto",
                }}
              >
                {dateErrorMessage}
              </Typography>
            </div>
          )}
          <div className="two-per-line">
            <Typography color="text.secondary" sx={{ ml: 1.5 }}>
              *You can check in between 1-10 PM on the day you arrive
            </Typography>
          </div>
          <div className="two-per-line">
            <Typography color="text.secondary" sx={{ ml: 1.5 }}>
              *Check-out is by 11AM
            </Typography>
          </div>
          {numNights !== 1 ? (
            <div className="one-per-line">
              <Typography
                color="text.secondary"
                sx={{ ml: 1.5, fontWeight: "bold" }}
              >
                Your current stay is: {numNights} nights
              </Typography>
            </div>
          ) : (
            <div className="one-per-line">
              <Typography color="text.secondary" sx={{ ml: 1.5 }}>
                Your current stay is: {numNights} night
              </Typography>
            </div>
          )}
          <div className="two-per-line">
            <TextField
              value={numAdults}
              onChange={(event) => {
                setNumAdults(event.target.value);
                setNumAdultsError(false);
              }}
              sx={{ margin: "6px" }}
              label="Number of Adults*"
              fullWidth
              error={numAdultsError}
              helperText={numAdultsError ? "Required" : ""}
            />
          </div>
          <div className="two-per-line">
            <TextField
              value={numChildren}
              onChange={(event) => {
                setNumChildren(event.target.value);
                setNumChildrenError(false);
              }}
              sx={{ margin: "6px" }}
              label="Number of Children (Under Age 18)"
              fullWidth
              error={numChildrenError}
              helperText={numChildrenError ? "Required" : ""}
            />
          </div>
          <div className="two-per-line">
            <Typography color="text.secondary" sx={{ ml: 1.5 }}>
              *2 adults are covered with the site fee. Each extra adult is $10 /
              night in peak season, and $8 / night in value season
            </Typography>
          </div>
          <div className="two-per-line">
            <TextField
              value={childrenAges}
              onChange={(event) => {
                setChildrenAges(event.target.value);
              }}
              sx={{ margin: "6px" }}
              label="Children Ages"
              fullWidth
            />
          </div>
          {/* "Camping Unit" field. Doesn't show if cabin is their requested siteType */}
          {siteType !== "Cabin" ? (
            <div className="two-per-line">
              <TextField
                sx={{ margin: "6px" }}
                label="Select Camping Unit"
                select
                value={campingUnit}
                onChange={(event) => {
                  setCampingUnit(event.target.value);
                  setCampingUnitError(false);
                }}
                fullWidth
                error={campingUnitError}
                helperText={campingUnitError ? "Required" : ""}
              >
                <MenuItem value="Motorhome">Motorhome</MenuItem>
                <MenuItem value="Motorhome w/Slide">Motorhome w/Slide</MenuItem>
                <MenuItem value="Travel Trailer">Travel Trailer</MenuItem>
                <MenuItem value="Travel Trailer w/Slide">
                  Travel Trailer w/Slide
                </MenuItem>
                <MenuItem value="Travel Trailer - Hybrid">
                  Travel Trailer - Hybrid
                </MenuItem>
                <MenuItem value="5th Wheel">5th Wheel</MenuItem>
                <MenuItem value="5th Wheel w/Slide">5th Wheel w/Slide</MenuItem>
                <MenuItem value="Pop-up Trailer">Pop-up Trailer</MenuItem>
                <MenuItem value="Camper Truck">Camping Truck</MenuItem>
                <MenuItem value="Camper Van">Camping Van</MenuItem>
                <MenuItem value="Tent">Tent</MenuItem>
                <MenuItem value="Cabin">Cabin</MenuItem>
              </TextField>
            </div>
          ) : null}
          {/* Show the "Length in feet of camping unit" option if the requested type of campsite is not a cabin. */}
          {campingUnit !== "Cabin" ? (
            <div className="one-per-line">
              <TextField
                value={campingUnitLength}
                onChange={(event) => {
                  setCampingUnitLength(event.target.value);
                  setCampingUnitLengthError(false);
                }}
                sx={{ margin: "6px" }}
                label="Camping Unit Length in Feet*"
                fullWidth
                error={campingUnitLengthError}
                helperText={campingUnitLengthError ? "Required" : ""}
              />
            </div>
          ) : null}
          <div className="one-per-line">
            <Typography gutterBottom color="text.secondary" sx={{ ml: 1.5 }}>
              *For trailers, put the length of your trailer when fully extended
            </Typography>
          </div>
          <div className="one-per-line">
            <TextField
              value={numElectricVehicles}
              onChange={(event) => {
                setNumElectricVehicles(event.target.value);
              }}
              sx={{ margin: "6px" }}
              label="# Electric Vehicles*"
              type="number"
              inputProps={{
                min: 0,
              }}
              fullWidth
            />
          </div>
          <div className="one-per-line">
            <Typography color="text.secondary" sx={{ ml: 1.5 }}>
              *One-time $25 charge per stay, per electric vehicle that you will
              be charging on your site. Charging is only permitted from 9PM -
              7AM.
            </Typography>
          </div>
          {/* Extras */}
          <Box className="one-per-line">
            <FormControl>
              <FormLabel sx={{ color: "black" }}>
                {" "}
                Extra things we'll be bringing:{" "}
              </FormLabel>
              <FormGroup>
                <FormControlLabel
                  label="Dining Tent / Screen Tent"
                  control={
                    <Checkbox
                      value="Dining Tent"
                      checked={extras.includes("Dining Tent")}
                      onChange={handleExtrasChange}
                    />
                  }
                />
                <FormControlLabel
                  label="Extra Car: $8.00 / night (one car is covered, only check this if you'll have two)"
                  control={
                    <Checkbox
                      value="Extra Car"
                      checked={extras.includes("Extra Car")}
                      onChange={handleExtrasChange}
                    />
                  }
                />
              </FormGroup>
            </FormControl>
          </Box>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={5}>
              <TextField
                sx={{ margin: "6px" }}
                label="Estimated Check-in Time (No Check-ins After 10pm)"
                select
                value={checkInTime}
                onChange={(event) => {
                  setCheckInTime(event.target.value);
                }}
                fullWidth
              >
                <MenuItem value="Afternoon (1:00pm - 5:00pm)">
                  Afternoon (1:00pm - 5:00pm)
                </MenuItem>
                <MenuItem value="Evening (5:00pm - 8:00pm)">
                  Evening (5:00pm - 8:00pm)
                </MenuItem>
                <MenuItem value="Night (8:00pm - 10:00pm)">
                  Night (8:00pm - 10:00pm)
                </MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} sm={5}></Grid>

            <Grid
              value={extraInfo}
              onChange={(event) => {
                setExtraInfo(event.target.value);
              }}
              item
              xs={12}
              sm={5}
            >
              <TextField
                sx={{ margin: "6px" }}
                label="Additional information (optional)"
                multiline
                rows={5}
                fullWidth
              />
            </Grid>
          </Grid>
          {/* Deposit and cancellation policy */}
          <div className="one-per-line">
            <Typography variant="h6">Deposit & Cancellation Policy:</Typography>
          </div>
          <div className="deposit-policy">
            <Typography variant="p">
              Upon review and acceptance of your booking, an initial deposit of
              two nights camping fee along with the reservation fee of $8.85 +
              tax will be processed on your credit card. The balance for any
              remaining nights is due on your scheduled check in day. Deposit
              refunds for cancelled reservations depend on how much notice you
              provide: 30+ days = 75%; 14-29 days = 50%; less than 14 days =
              25%.
            </Typography>
          </div>
          <div className="deposit-policy">
            <Typography variant="p">
              *For one night stays, the entire camping amount is paid as a
              deposit and becomes non-refundable 14 days prior to the scheduled
              arrival date.
            </Typography>
          </div>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="center">
                    Number of nights in advance of the scheduled arrival date
                  </TableCell>
                  <TableCell align="center">
                    Refundable portion of the deposit
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell align="center">30+ days</TableCell>
                  <TableCell align="center">75% of deposit</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="center">14 - 29 days</TableCell>
                  <TableCell align="center">50% of deposit</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="center">Less than 14 days</TableCell>
                  <TableCell align="center">25% of deposit</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <Box sx={{ margin: "7px auto", padding: "5px" }}>
            <FormControlLabel
              label="I accept the terms of your cancellation policy and have read and accept the park rules"
              control={
                <Checkbox
                  checked={acceptTerms}
                  onChange={(event) => {
                    setAcceptTerms(event.target.checked);
                    setAcceptTermsMessage("");
                  }}
                />
              }
            />
          </Box>
          {acceptTermsMessage === "" ? null : (
            <div className="one-per-line">
              <Typography
                sx={{
                  backgroundColor: "#ffee90",
                  p: 2,
                  clear: "both",
                  width: "auto",
                }}
              >
                {acceptTermsMessage}
              </Typography>
            </div>
          )}
          <div className="one-per-line">
            <Button
              onClick={async () => {
                setLoading(true);
                var checkoutTicket = "";

                //CHECK THAT ALL FIELDS HAVE BEEN ENTERED
                var errorInForm = false;

                if (!/\S/.test(firstName)) {
                  setFirstNameError(true);
                  errorInForm = true;
                }

                if (!/\S/.test(lastName)) {
                  setLastNameError(true);
                  errorInForm = true;
                }

                const emailRegex =
                  /[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,8}(.[a-z{2,8}])?/g;
                if (!emailRegex.test(email)) {
                  setEmailError(true);
                  errorInForm = true;
                }

                if (!/\S/.test(phoneNumber)) {
                  setPhoneNumberError(true);
                  errorInForm = true;
                }

                if (!/\S/.test(siteType)) {
                  setSiteTypeError(true);
                  errorInForm = true;
                }

                if (!/\S/.test(campingUnit)) {
                  setCampingUnitError(true);
                  errorInForm = true;
                }

                if (typeof arrivalDate === "undefined") {
                  setDateErrorMessage(
                    "Please select an arrival date and departure date.",
                  );
                  errorInForm = true;
                }

                if (typeof departureDate === "undefined") {
                  setDateErrorMessage(
                    "Please select an arrival date and departure date.",
                  );
                  errorInForm = true;
                }

                if (!/\S/.test(numAdults)) {
                  setNumAdultsError(true);
                  errorInForm = true;
                }

                if (!/\S/.test(numChildren)) {
                  setNumChildrenError(true);
                  errorInForm = true;
                }

                //make sure that either their country isn't canada, or they entered a valid postal code
                if (
                  canadaOrOther === "Canada" &&
                  !/^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i.test(
                    postalCode,
                  )
                ) {
                  setPostalCodeError(true);
                  errorInForm = true;
                }

                //make sure the camping unit length has been entered if they're not in a tent / cabin
                const UNITS_REQUIRING_LENGTH = [
                  "Motorhome",
                  "Motorhome w/Slide",
                  "Travel Trailer",
                  "Travel Trailer w/Slide",
                  "Travel Trailer - Hybrid",
                  "5th Wheel",
                  "5th Wheel w/Slide",
                  "Pop-up Trailer",
                  "Camper Truck",
                  "Camper Van",
                ];

                if (
                  UNITS_REQUIRING_LENGTH.includes(campingUnit) &&
                  !/\S/.test(campingUnitLength)
                ) {
                  setCampingUnitLengthError(true);
                  errorInForm = true;
                }

                if (errorInForm) {
                  ref.current.scrollIntoView({ behavior: "smooth" });
                  setLoading(false);
                  return;
                }

                if (acceptTerms === false) {
                  setAcceptTermsMessage(
                    "Please read and accept our cancellation policy and park rules then check the box.",
                  );
                  setLoading(false);
                  return;
                }

                //if it made it to here all info is good, start the moneris checkout

                //set up monerisCheckout object
                var myCheckout = new window.monerisCheckout();
                //testing:
                // myCheckout.setMode("qa");

                //production:
                myCheckout.setMode("prod");
                myCheckout.setCheckoutDiv("monerisCheckout");
                //set callbacks
                myCheckout.setCallback("page_loaded", () =>
                  setMonerisCheckoutLoaded(true),
                );
                myCheckout.setCallback("cancel_transaction", () => {
                  myCheckout.closeCheckout();
                  setMonerisCheckoutLoaded(false);
                });
                myCheckout.setCallback("error_event", () => {
                  myCheckout.closeCheckout();
                  setAcceptTermsMessage(
                    "Something went wrong during the payment process. Please give us a call at 519-596-2523, or email mail@landsendpark.com",
                  );
                  setMonerisCheckoutLoaded(false);
                });
                //got rid of the payment_receipt callback because it didn't fire on errors. Can delete this
                //if it works checking it on the back end
                // myCheckout.setCallback("payment_receipt", async (receipt) => {
                //   console.log("Full receipt object in payment_receipt: ", receipt)
                // });
                myCheckout.setCallback("payment_complete", async (receipt) => {
                  //send booking info and checkout ticket to back end
                  //if the country isn't canada and nothing was entered for Specify Country, set country to other
                  var countryToSend = country;
                  if (canadaOrOther === "Other" && !/\S/.test(country)) {
                    countryToSend = "Other (Not Canada)";
                  }

                  let reservationObject = {
                    firstName: firstName,
                    lastName: lastName,
                    email: email,
                    phoneNumber: phoneNumber,
                    siteType: siteType,
                    backupSiteType: backupSiteType,
                    arrivalDate: arrivalDate.$d.toDateString(),
                    departureDate: departureDate.$d.toDateString(),
                    numAdults: numAdults,
                    numChildren: numChildren,
                    childrenAges: childrenAges,
                    campingUnit: campingUnit,
                    campingUnitLength: campingUnitLength,
                    screenTentOrDiningTent: extras.includes("Dining Tent"),
                    extraCar: extras.includes("Extra Car"),
                    numElectricVehicles: numElectricVehicles,
                    checkInTime: checkInTime,
                    extraInfo: extraInfo,
                    numNights: "" + numNights,
                    postalCode: postalCode,
                    country: countryToSend,
                    address: address,
                    checkoutTicket: checkoutTicket,
                  };

                  try {
                    //this is the second fetch to execute. If it made it here then the moneris checkout went ok
                    const response = await fetch(
                      //the test url that worked was "http://landsendpark-001-site1.ktempurl.com/api/Reservation"
                      //https://win1083.site4now.net:8172/MsDeploy.axd?site=landsendpark-001-site1 did not work
                      `${URL}/api/Reservation`,
                      {
                        method: "Post",
                        headers: {
                          "Content-Type": "application/json",
                        },
                        body: JSON.stringify(reservationObject),
                      },
                    );
                    if (response.ok) {
                      //the booking form has been successfully sent, now navigate to the booking success / thanks page
                      navigate("/bookingformsent");
                    } else {
                      myCheckout.closeCheckout();
                      setMonerisCheckoutLoaded(false);
                      setLoading(false);
                      setDialogIsOpen(true);
                      console.log("inside of the else for response.ok");
                    }
                  } catch (error) {
                    let messageObject = {
                      message: `Booking form error:
Name: ${error.name}
Message: ${error.message}
Stack: ${error.stack}`,
                    };

                    try {
                      const response = await fetch(
                        "https://landsendparktest.com/api/message/errorlog",
                        {
                          method: "POST",
                          headers: {
                            "Content-Type": "application/json",
                          },
                          body: JSON.stringify(messageObject),
                        },
                      );

                      console.log(response.status);
                    } catch (logError) {
                      console.error("Failed to send error log:", logError);
                    }

                    navigate("/bookingerror");
                    console.log("inside of the catch");
                  }
                  myCheckout.closeCheckout();
                  setMonerisCheckoutLoaded(false);
                  setLoading(false);
                }); //end payment_complete callback function

                // tell my server to get a ticket number from moneris
                const asyncFunction = async () => {
                  //check if the arrivalDate and departureDate are value season (if either one isn't in the summer,
                  //make the nightly cost of the deposit be the value season rate)

                  const arrivalDateToCompare = arrivalDate.$d.getTime();
                  const departureDateToCompare = arrivalDate.$d.getTime();
                  //to be summer rates, neither the arrival nor departure can be in the summer
                  var usePeak2025RatesForDeposit = false;
                  var useValue2025RatesForDeposit = false;
                  var usePeak2026RatesForDeposit = false;
                  var useValue2026RatesForDeposit = false;
                  if (
                    arrivalDateToCompare > summerStart2025 &&
                    arrivalDateToCompare <= summerEnd2025 &&
                    departureDateToCompare > summerStart2025 &&
                    departureDateToCompare <= summerEnd2025
                  ) {
                    usePeak2025RatesForDeposit = true;
                  } else if (
                    arrivalDateToCompare > summerEnd2025 &&
                    arrivalDateToCompare <= closeDate2025
                  ) {
                    useValue2025RatesForDeposit = true;
                  } else if (
                    arrivalDateToCompare >= summerStart2026 &&
                    arrivalDateToCompare <= summerEnd2026 &&
                    departureDateToCompare > summerStart2026 &&
                    departureDateToCompare <= summerEnd2026
                  ) {
                    usePeak2026RatesForDeposit = true;
                  } else {
                    useValue2026RatesForDeposit = true;
                  }

                  //find the nightly cost of the deposit based on if it's summer rates and the site type
                  var nightlyCostForDeposit;
                  if (siteType === "Unserviced" && usePeak2025RatesForDeposit) {
                    nightlyCostForDeposit = 54;
                  } else if (
                    siteType === "Regular Serviced" &&
                    usePeak2025RatesForDeposit
                  ) {
                    nightlyCostForDeposit = 65;
                  } else if (
                    siteType === "Premium Serviced" &&
                    usePeak2025RatesForDeposit
                  ) {
                    nightlyCostForDeposit = 75;
                  } else if (
                    siteType === "50 Amp" &&
                    usePeak2025RatesForDeposit
                  ) {
                    nightlyCostForDeposit = 78;
                  } else if (
                    siteType === "Cabin" &&
                    usePeak2025RatesForDeposit
                  ) {
                    nightlyCostForDeposit = 112;
                  } else if (
                    siteType === "Unserviced" &&
                    useValue2025RatesForDeposit
                  ) {
                    nightlyCostForDeposit = 44;
                  } else if (
                    siteType === "Regular Serviced" &&
                    useValue2025RatesForDeposit
                  ) {
                    nightlyCostForDeposit = 53;
                  } else if (
                    siteType === "Premium Serviced" &&
                    useValue2025RatesForDeposit
                  ) {
                    nightlyCostForDeposit = 62;
                  } else if (
                    siteType === "50 Amp" &&
                    useValue2025RatesForDeposit
                  ) {
                    nightlyCostForDeposit = 65;
                  } else if (
                    siteType === "Cabin" &&
                    useValue2025RatesForDeposit
                  ) {
                    nightlyCostForDeposit = 91;
                  }
                  //peak season 2026
                  else if (
                    siteType === "Unserviced" &&
                    usePeak2026RatesForDeposit
                  ) {
                    nightlyCostForDeposit = 54;
                  } else if (
                    siteType === "Regular Serviced" &&
                    usePeak2026RatesForDeposit
                  ) {
                    nightlyCostForDeposit = 66;
                  } else if (
                    siteType === "Premium Serviced" &&
                    usePeak2026RatesForDeposit
                  ) {
                    nightlyCostForDeposit = 77;
                  } else if (
                    siteType === "50 Amp" &&
                    usePeak2026RatesForDeposit
                  ) {
                    nightlyCostForDeposit = 80;
                  } else if (
                    siteType === "Cabin" &&
                    usePeak2026RatesForDeposit
                  ) {
                    nightlyCostForDeposit = 112;
                  }
                  //value season 2026
                  else if (
                    siteType === "Unserviced" &&
                    useValue2026RatesForDeposit
                  ) {
                    nightlyCostForDeposit = 44;
                  } else if (
                    siteType === "Regular Serviced" &&
                    useValue2026RatesForDeposit
                  ) {
                    nightlyCostForDeposit = 54;
                  } else if (
                    siteType === "Premium Serviced" &&
                    useValue2026RatesForDeposit
                  ) {
                    nightlyCostForDeposit = 64;
                  } else if (
                    siteType === "50 Amp" &&
                    useValue2026RatesForDeposit
                  ) {
                    nightlyCostForDeposit = 67;
                  } else if (
                    siteType === "Cabin" &&
                    useValue2026RatesForDeposit
                  ) {
                    nightlyCostForDeposit = 91;
                  }

                  //take 1 (if the stay is 1 night) or 2 nights for the deposit
                  var numNightsForDeposit;
                  numNights === 1
                    ? (numNightsForDeposit = 1)
                    : (numNightsForDeposit = 2);

                  //find the total deposit amount
                  var totalDepositAmount = (
                    (numNightsForDeposit * nightlyCostForDeposit + 8.85) *
                    1.13
                  ).toFixed(2);

                  if (firstName === "TEST RESERVATION") {
                    totalDepositAmount = (0.15).toFixed(2);
                  }

                  //this is the first fetch to execute
                  // totalDepositAmount = 0.01;//for testing make the deposit 0.10
                  const response = await fetch(
                    //https://win1083.site4now.net:8172/MsDeploy.axd?site=landsendpark-001-site1/
                    `${URL}/api/Checkout/${totalDepositAmount}`,
                    {
                      method: "POST",
                    },
                  );
                  const responseBody = await response.json();
                  myCheckout.startCheckout(responseBody.response.ticket);
                  console.log(
                    "The responseBody.response.ticket is " +
                      responseBody.response.ticket,
                  );
                  //save the ticket. It gets sent in the booking request email to build the link to
                  //the transaction in Moneris Merchant Resource Center
                  checkoutTicket = responseBody.response.ticket;
                };

                asyncFunction();
              }}
              type="submit"
              variant="contained"
            >
              Continue to payment
            </Button>
            <ClipLoader loading={loading} size={14}></ClipLoader>
          </div>{" "}
        </div>
      ) : null}
    </div>
  );
};
